export const RAW_DATA_TAB_LOAD_DATA = "RAW_DATA_TAB_LOAD_DATA";
export const RAW_DATA_TAB_LOAD_DATA_RESULT = "RAW_DATA_TAB_LOAD_DATA_RESULT";
export const RAW_DATA_TAB_SET_FILTERS = "RAW_DATA_TAB_SET_FILTERS";
export const RAW_DATA_TAB_SET_BEFORE_RANGE_DATE = "RAW_DATA_TAB_SET_BEFORE_RANGE_DATE";
